import * as React from "react";
import { useState, useEffect } from "react";

const InspectIcons = ({ toggle, setToggle, color }) => {
    const [theme, setTheme] = useState("light");

    // Retrieve the theme from localStorage or set default
    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") || "light";
        setTheme(savedTheme);
    }, [toggle]);

    // Define theme-specific colors
    const themeColors = {
        light: "#03A9F4", // Light theme color
        dark: "#FFEB3B",  // Dark theme color
    };

    const fillColor = themeColors[theme]; // Get the color based on the theme

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            fill="none"
            stroke={fillColor} // Apply the theme-specific stroke color
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
        >
            <path d="M19 11V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h7" />
            <path d="m12 12 4.166 10 1.48-4.355L22 16.166 12 12zM18 18l3 3" />
        </svg>
    );
};

export default InspectIcons;
